import { createAction, props } from "@ngrx/store";
import { ChildDeactivationRequest } from "@core/models/domain/child-deactivation.domain";
import {
  DeclineChildDeactivationRequest,
  ExemptChildDeactivationRequest
} from "@core/models/request/child-deactivation.request";
import { SchoolUserExemptionReason } from "@core/models/domain/account.domain";

// LOAD PENDING REQUESTS
export const loadRequests = createAction('[ChildDeactivation] Load Requests');
export const loadRequestsSuccess = createAction(
  '[ChildDeactivation] Load Requests Success',
  props<{ requests: ChildDeactivationRequest[] }>()
);
export const loadRequestsFailure = createAction(
  '[ChildDeactivation] Load Requests Failure',
  props<{ error: any }>()
);

// LOAD RESOLVED HISTORY
export const loadResolvedRequests = createAction('[ChildDeactivation] Load Resolved Requests');
export const loadResolvedRequestsSuccess = createAction(
  '[ChildDeactivation] Load Resolved Requests Success',
  props<{ requests: ChildDeactivationRequest[] }>()
);
export const loadResolvedRequestsFailure = createAction(
  '[ChildDeactivation] Load Resolved Requests Failure',
  props<{ error: any }>()
);

// APPROVE: the child's account is deactivated and the pupil leaves the roster
export const approveRequest = createAction(
  '[ChildDeactivation] Approve Request',
  props<{ requestId: string }>()
);
export const approveRequestSuccess = createAction(
  '[ChildDeactivation] Approve Request Success',
  props<{ requestId: string }>()
);
export const approveRequestFailure = createAction(
  '[ChildDeactivation] Approve Request Failure',
  props<{ requestId: string; error: any }>()
);

// DECLINE: nothing changes, but the school owes the parent a reason
export const declineRequest = createAction(
  '[ChildDeactivation] Decline Request',
  props<{ request: DeclineChildDeactivationRequest }>()
);
export const declineRequestSuccess = createAction(
  '[ChildDeactivation] Decline Request Success',
  props<{ requestId: string; reason: string }>()
);
export const declineRequestFailure = createAction(
  '[ChildDeactivation] Decline Request Failure',
  props<{ requestId: string; error: any }>()
);

// EXEMPT: the pupil stays on the roster but is exempt from LOQT
export const exemptRequest = createAction(
  '[ChildDeactivation] Exempt Request',
  props<{ request: ExemptChildDeactivationRequest }>()
);
export const exemptRequestSuccess = createAction(
  '[ChildDeactivation] Exempt Request Success',
  props<{ requestId: string; exemptionReason: SchoolUserExemptionReason; exemptionNote?: string }>()
);
export const exemptRequestFailure = createAction(
  '[ChildDeactivation] Exempt Request Failure',
  props<{ requestId: string; error: any }>()
);
